import React, { useEffect } from "react"
import PropTypes from "prop-types"
import styles from "./direct-link.module.scss"
import { MdKeyboardArrowRight } from "react-icons/md"
import classNames from "classnames"
import { Link } from "gatsby"
import { use } from "react"

const DirectLink = ({
  linkTo,
  to,
  text,
  className,
  showText,
  showArrow,
  isUpload,
  isEdit,
  id,
  page,
  issue,
  meetingNum,
}) => {
  const [resolvedTo, setResolvedTo] = React.useState(false)

  useEffect(() => {
    if (isUpload) {
      if (page === "newsletters") {
        setResolvedTo("/upload-newsletters")
      }
      if (page === "meetings") {
        setResolvedTo("/upload-meetings")
      }
    } else {
      setResolvedTo(to)
    }
    
  }, [])


  if (resolvedTo) {
    return (
      <Link
        to={resolvedTo}
        state={{
          isEdit,
          id,
          ...(issue !== undefined && issue !== null ? { issue } : {}),
          ...(meetingNum !== undefined && meetingNum !== null
            ? { meetingNum }
            : {}),
        }}
        className={classNames(styles?.directLink, className)}
      >
        {showArrow && (
          <span>
            <MdKeyboardArrowRight />
          </span>
        )}
        {showText && text}
      </Link>
    )
  } else {
    return (
      <a href={linkTo} className={classNames(styles?.directLink, className)} target="_blank" rel="noopener noreferrer">
        {showArrow && (
          <span>
            <MdKeyboardArrowRight />
          </span>
        )}
        {showText && text}
      </a>
    )
  }
}

DirectLink.defaultProps = {
  linkTo: "/",
  text: "Read and Download",
  showText: true,
  showArrow: true,
}

DirectLink.propTypes = {
  linkTo: PropTypes.string,
  to: PropTypes.string,
  text: PropTypes.string,
  className: PropTypes.string,
  showText: PropTypes.bool,
  showArrow: PropTypes.bool,
}

export default DirectLink
